import { worker } from "../mocks/browser";
import {
  setAccessToken,
  setUserInfoFromLocalStorage,
} from "../shared/utils/auth";
import { demoLoginDto } from "./mockData/user";
import { demoHandlers } from "./handlers";
import i18next from "i18next";

async function startDemoWorker(): Promise<void> {
  await worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: { url: "/mockServiceWorker.js" },
  });
  worker.use(...demoHandlers);
  setAccessToken("demo-token");
  setUserInfoFromLocalStorage(demoLoginDto);
}

export async function initDemo(): Promise<void> {
  // 1. MSW worker 시작 + 데모 핸들러 등록 (기존 핸들러보다 우선)
  await startDemoWorker();
  // 2. SW 교체/재시작 시 MSW 재초기화
  // - bfcache 복원: bootstrap()이 재실행되지 않아 activeClientIds가 비는 경우
  // - DevTools 열기: Chrome이 SW를 업데이트/재시작시켜 새 SW의 activeClientIds가 비는 경우
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      startDemoWorker();
    }
  });
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // 새 SW가 제어권을 가져가면 activeClientIds가 초기화됨.
    // 핸들러는 worker 객체에 이미 메모리에 있으므로 MOCK_ACTIVATE만 재전송.
    navigator.serviceWorker.controller?.postMessage("MOCK_ACTIVATE");
  });

  // 3. ?lang= 파라미터로 언어 및 dir 설정
  const lang = new URLSearchParams(window.location.search).get("lang");
  if (lang && ["ko", "en", "ar"].includes(lang)) {
    await i18next.changeLanguage(lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
  }
}
